webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(92),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_index__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_acceleration__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_acceleration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_acceleration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_amount_of_subtance__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_amount_of_subtance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_amount_of_subtance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_angle__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_angle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_angle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_area__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_astronomical__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_astronomical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_astronomical__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_blood_sugar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_blood_sugar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_blood_sugar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_capacitance__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_capacitance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_capacitance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_computer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_computer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_computer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_cooking__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_cooking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_cooking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_data_transfer__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_data_transfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_data_transfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_density__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_density___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_density__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_dynamic_viscosity__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_dynamic_viscosity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_dynamic_viscosity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_electric_charge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_electric_charge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_electric_charge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_electrical_resistance__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_electrical_resistance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_electrical_resistance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_energy__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_energy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_energy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_force__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_force___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_force__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_illuminance__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_illuminance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_illuminance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_inductance__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_inductance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_inductance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_length__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_length___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_length__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_temperature__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_temperature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_temperature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_volume__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_volume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_volume__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_weight__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_weight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_weight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_time__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_time__);




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_index___default.a
  }, {
    path: '/acceleration',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_acceleration___default.a
  }, {
    path: '/amount-of-substance',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_amount_of_subtance___default.a
  }, {
    path: '/angle',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_angle___default.a
  }, {
    path: '/area',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_area___default.a
  }, {
    path: '/astronomical',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_astronomical___default.a
  }, {
    path: '/blood-sugar',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_blood_sugar___default.a
  }, {
    path: '/capacitance',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_capacitance___default.a
  }, {
    path: '/computer',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_computer___default.a
  }, {
    path: '/cooking',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_cooking___default.a
  }, {
    path: '/data-transfer',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_data_transfer___default.a
  }, {
    path: '/density',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_density___default.a
  }, {
    path: '/dynamic-viscosity',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_dynamic_viscosity___default.a
  }, {
    path: '/electric-charge',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_electric_charge___default.a
  }, {
    path: '/electrical-resistance',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_electrical_resistance___default.a
  }, {
    path: '/energy',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_energy___default.a
  }, {
    path: '/force',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_force___default.a
  }, {
    path: '/illuminance',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_illuminance___default.a
  }, {
    path: '/inductance',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_inductance___default.a
  }, {
    path: '/length',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_length___default.a
  }, {
    path: '/temperature',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_temperature___default.a
  }, {
    path: '/volume',
    component: __WEBPACK_IMPORTED_MODULE_23__pages_volume___default.a
  }, {
    path: '/weight',
    component: __WEBPACK_IMPORTED_MODULE_24__pages_weight___default.a
  }, {
    path: '/time',
    component: __WEBPACK_IMPORTED_MODULE_25__pages_time___default.a
  }]
}));

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(117);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    unit: []
  },
  mutations: {
    SET_UNIT: function SET_UNIT(state, unit) {
      state.unit = unit;
    }
  },
  actions: {
    setUnit: function setUnit(_ref, unit) {
      var commit = _ref.commit;

      commit('SET_UNIT', unit);
    }
  },
  getters: {
    getUnitByText: function getUnitByText(state) {
      return function (text) {
        return state.unit.filter(function (val) {
          return val.text === text;
        })[0];
      };
    }
  }
}));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(106),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            clipped: false,
            drawer: true,
            fixed: false,
            items: [{ heading: 'Home' }, { icon: 'home', text: 'Home', href: '/' }, { divider: true }, { heading: 'Tool' }, { icon: 'straighten', text: 'Length', href: '/length' }, { icon: 'thermostat', text: 'Temperature', href: '/temperature' }, { icon: 'volume_down', text: 'Volume', href: '/volume' }, { icon: 'balance', text: 'Weight', href: '/weight' }, { icon: 'schedule', text: 'Time', href: '/time' }, { icon: 'network_check', text: 'Acceleration', href: '/acceleration' }, {
                icon: 'hourglass_bottom',
                text: 'Amount of substance',
                href: '/amount-of-substance'
            }, { icon: 'square_foot', text: 'Angle', href: '/angle' }, { icon: 'crop', text: 'Area', href: '/area' }, { icon: 'auto_awesome', text: 'Astronomical', href: '/astronomical' }, { icon: 'water_drop', text: 'Blood Sugar', href: '/blood-sugar' }, { icon: 'battery_charging_full', text: 'Capacitance', href: '/capacitance' }, {
                icon: 'save',
                text: 'Computer Data Storage',
                href: '/computer'
            }, { icon: 'outdoor_grill', text: 'Cooking', href: '/cooking' }, { icon: 'move_up', text: 'Data Transfer', href: '/data-transfer' }, { icon: 'zoom_in_map', text: 'Density', href: '/density' }, {
                icon: 'blur_on',
                text: 'Dynamic Viscosity',
                href: '/dynamic-viscosity'
            }, {
                icon: 'electrical_services',
                text: 'Electric Charge',
                href: '/electric-charge'
            }, {
                icon: 'wifi_protected_setup',
                text: 'Electrical Resistance',
                href: '/electrical-resistance'
            }, { icon: 'electric_bolt', text: 'Energy', href: '/energy' }, { icon: 'diversity_2', text: 'Force', href: '/force' }, { icon: 'emoji_objects', text: 'Illuminance', href: '/illuminance' }, { icon: 'functions', text: 'Inductance', href: '/inductance' }],
            miniVariant: true,
            title: 'VajraLab => Unit Converter'
        };
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_temperature__ = __webpack_require__(35);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type'],
  data: function data() {
    return {
      unitFrom: {
        text: this.$store.state.unit[0].text,
        val: 1
      },
      unitTo: {
        text: this.$store.state.unit[0].text,
        val: 1
      },
      valueFrom: 0,
      valueTo: 0,
      snackbar: false,
      exponent: false,
      round: false,
      roundNumber: 0
    };
  },

  computed: {
    unit: function unit() {
      return this.$store.state.unit;
    }
  },
  watch: {
    $data: {
      handler: function handler(val, oldVal) {
        this.unitFrom.val = this.$store.getters.getUnitByText(this.unitFrom.text).val;
        this.unitTo.val = this.$store.getters.getUnitByText(this.unitTo.text).val;
        if (!isNaN(this.valueFrom)) {
          this.valueTo = this.convert();
        }
      },
      deep: true
    }
  },
  methods: {
    convert: function convert() {
      var val = this.unitTo.val * this.valueFrom / this.unitFrom.val;
      if (this.type === 'temperature') {
        var valueTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_temperature__["a" /* default */])(this.unitFrom.text, this.unitTo.text, this.valueFrom);
        val = valueTo;
      }
      if (!this.exponent) {
        val = this.noExponents(val);
      }
      if (this.round) {
        val = parseFloat(val);
        val = val.toFixed(this.roundNumber);
      }
      return val.toString();
    },
    copy: function copy() {
      this.snackbar = true;
      var data = this.valueTo;
      var input = document.createElement('input');
      input.value = data;
      input.id = 'inpCopy';
      document.body.appendChild(input);
      var text = document.getElementById('inpCopy');
      text.select();
      document.execCommand('copy');
      text.remove();
    },
    noExponents: function noExponents(number) {
      var data = String(number).split(/[eE]/);
      if (data.length == 1) return data[0];

      var z = '',
          sign = number < 0 ? '-' : '',
          str = data[0].replace('.', ''),
          mag = Number(data[1]) + 1;

      if (mag < 0) {
        z = sign + '0.';
        while (mag++) {
          z += '0';
        }return z + str.replace(/^\-/, '');
      }
      mag -= str.length;
      while (mag--) {
        z += '0';
      }return str + z;
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'meter / square second (m/sec²)',
        val: 1
      }, {
        text: 'centimeter / square second (cm/sec²)',
        val: 100
      }, {
        text: 'foot / square second (ft/sec²)',
        val: 3.280839895
      }, {
        text: 'standard gravity (grav)',
        val: 0.1019716213
      }, {
        text: 'gal(cm/s²)',
        val: 100
      }, {
        text: 'g-unit',
        val: 0.1019716213
      }, {
        text: 'kilometer / square hour (km/h²)',
        val: 12960
      }, {
        text: 'kilometer / hour second(km/h-s)',
        val: 3.6
      }, {
        text: 'mile / hour minute(mi/h-min)',
        val: 134.21617752
      }, {
        text: 'mile / hour second (mi/hr-s)',
        val: 2.2369362921
      }, {
        text: 'mile / square second (mi/sec²)',
        val: 0.00062137119224
      }, {
        text: 'inch / square second (in/s²)',
        val: 39.37007874
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'millimole(mmol)',
        val: 1
      }, {
        text: 'mol(mol)',
        val: 0.001
      }, {
        text: 'gram-mole(g-mol)',
        val: 0.001
      }, {
        text: 'kilomole(kmol)',
        val: 0.000001
      }, {
        text: 'pound mole(lb-mol)',
        val: 0.000002204622621849
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'degrees (deg)',
        val: 1
      }, {
        text: 'full circle',
        val: 0.002777777777778
      }, {
        text: 'grad',
        val: 1.111111111111
      }, {
        text: 'radians (rad)',
        val: 0.01745329251994
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'acre',
        val: 1
      }, {
        text: 'are (a)',
        val: 40.468564224
      }, {
        text: 'barn (b)',
        val: 4.0468564224e31
      }, {
        text: 'hectare (ha)',
        val: 0.40468564224
      }, {
        text: 'homestead',
        val: 0.00625
      }, {
        text: 'rood',
        val: 4
      }, {
        text: 'square centimeter (cm²)',
        val: 40468564.224
      }, {
        text: 'square foot (ft²)',
        val: 43560
      }, {
        text: 'square inch (in²)',
        val: 6272640
      }, {
        text: 'square kilometer (km²)',
        val: 0.0040468564224
      }, {
        text: 'square meter (m²)',
        val: 4046.8564224
      }, {
        text: 'square mile',
        val: 0.0015625
      }, {
        text: 'square millimeter (mm²)',
        val: 4046856422.4
      }, {
        text: 'square rod',
        val: 160
      }, {
        text: 'square yard (yd²)',
        val: 4840
      }, {
        text: 'township (twp)',
        val: 0.00004340277777778
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'parsec',
        val: 1
      }, {
        text: 'astronomical unit (AU)',
        val: 206264.8077366
      }, {
        text: 'kilometer (km)',
        val: 30856776029500
      }, {
        text: 'meter (m)',
        val: 30856776029500000
      }, {
        text: 'mile (mi)',
        val: 19167794603220
      }, {
        text: 'light-year (Julian)',
        val: 3.2615638
      }, {
        text: 'light-year (Gregorian)',
        val: 3.261630773938
      }, {
        text: 'light-year (traditional)',
        val: 3.263797747808
      }, {
        text: 'light-year (tropical / solar)',
        val: 3.261633463758
      }, {
        text: 'light-week',
        val: 170.1837397071
      }, {
        text: 'light-day',
        val: 1191.28617795
      }, {
        text: 'light-hour',
        val: 28590.8682708
      }, {
        text: 'light-minut',
        val: 1715452.096248
      }, {
        text: 'light-second',
        val: 102927125.7749
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'mmol / l',
        val: 1
      }, {
        text: 'mg / dl',
        val: 18
      }, {
        text: 'mg%',
        val: 18
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Abfarad (abF)',
        val: 1
      }, {
        text: 'Attofarad (aF)',
        val: 1e27
      }, {
        text: 'Centifarad (cF)',
        val: 100000000000
      }, {
        text: 'Coulomb per volt',
        val: 1000000000
      }, {
        text: 'Decafarad (daF)',
        val: 100000000
      }, {
        text: 'Decifarad (dF)',
        val: 10000000000
      }, {
        text: 'Exafarad (EF)',
        val: 1e-9
      }, {
        text: 'Farad (F)',
        val: 1000000000
      }, {
        text: 'Femtofarad (fF)',
        val: 1e24
      }, {
        text: 'Gigafarad (GF)',
        val: 1
      }, {
        text: 'Hectofarad (hF)',
        val: 10000000
      }, {
        text: 'Kilofarad (kF)',
        val: 1000000
      }, {
        text: 'Megafarad (MF)',
        val: 1000
      }, {
        text: 'Microfarad (µF)',
        val: 1000000000000000
      }, {
        text: 'Millifarad (mF)',
        val: 1000000000000
      }, {
        text: 'Nanofarad (nF)',
        val: 1000000000000
      }, {
        text: 'Petafarad (PF)',
        val: 0.000001
      }, {
        text: 'Picofarad (pF)',
        val: 1e21
      }, {
        text: 'Statfarad (statF)',
        val: 898755178736500000000
      }, {
        text: 'Terafarad (TF)',
        val: 0.001
      }, {
        text: 'Yoctofarad (yF)',
        val: 1e33
      }, {
        text: 'Yottafarad (YF)',
        val: 1e-15
      }, {
        text: 'Zeptofarad (zF)',
        val: 1e30
      }, {
        text: 'Zettafarad (ZF)',
        val: 1e-12
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'bit (bit)',
        val: 1
      }, {
        text: 'byte (B)',
        val: 0.125
      }, {
        text: 'kilobit (Kbit)',
        val: 0.0009765625
      }, {
        text: 'kilobyte (KB)',
        val: 0.0001220703125
      }, {
        text: 'megabit (Mbit)',
        val: 9.536743164063e-7
      }, {
        text: 'megabyte (MB)',
        val: 1.192092895508e-7
      }, {
        text: 'gigabit (Gbit)',
        val: 9.313225746155e-10
      }, {
        text: 'gigabyte (GB)',
        val: 1.164153218269e-10
      }, {
        text: 'terabit (Tbit)',
        val: 9.094947017729e-13
      }, {
        text: 'terabyte (TB)',
        val: 1.136912032962e-13
      }, {
        text: 'petabit (Pbit)',
        val: 8.881784160621e-16
      }, {
        text: 'petabyte (PB)',
        val: 2.953157760203e-10
      }, {
        text: 'floppy disk (3.5", DD)',
        val: 1.71507288469e-7
      }, {
        text: 'floppy disk (3.5", HD)',
        val: 8.575364417629e-8
      }, {
        text: 'floppy disk (5.25", DD)',
        val: 3.430145764374e-7
      }, {
        text: 'floppy disk (5.25", HD)',
        val: 1.02969474881e-7
      }, {
        text: 'Zip 100',
        val: 1.244624808896e-9
      }, {
        text: 'Zip 250',
        val: 4.978499258868e-10
      }, {
        text: 'Jaz 1GB',
        val: 1.164153218269e-10
      }, {
        text: 'Jaz 2GB',
        val: 5.820766091347e-11
      }, {
        text: 'CD (74 minute)',
        val: 1.835378818214e-10
      }, {
        text: 'CD (80 minute)',
        val: 1.697725383565e-10
      }, {
        text: 'DVD (1 layer)',
        val: 2.476922236383e-11
      }, {
        text: 'DVD (2 layer)',
        val: 1.369592500851e-11
      }, {
        text: 'Blu-ray (1 layer)',
        val: 4.656612873077e-12
      }, {
        text: 'Blu-ray (2 layer)',
        val: 2.328306436539e-12
      }, {
        text: 'HD-DVD (1 layer)',
        val: 7.761021454353e-12
      }, {
        text: 'HD-DVD (2 layer)',
        val: 3.880506847054e-12
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'cup [US]',
        val: 1
      }, {
        text: 'dash',
        val: 383.9999999956
      }, {
        text: 'dessertspoon [US]',
        val: 24.00000000106
      }, {
        text: 'dessertspoon [UK]',
        val: 19.98417216308
      }, {
        text: 'dram[US fluid]',
        val: 64
      }, {
        text: 'dram[UK fluid]',
        val: 66.61393477032
      }, {
        text: 'drop',
        val: 4607.999999938
      }, {
        text: 'fifth',
        val: 0.3125
      }, {
        text: 'fluid ounce [US fluid, fl oz]',
        val: 8
      }, {
        text: 'fluid ounce [UK fluid, fl oz]',
        val: 8.32674184629
      }, {
        text: 'gallon [US, fluid]',
        val: 0.0625
      }, {
        text: 'gallon [US, dry]',
        val: 0.05371013825974
      }, {
        text: 'gallon [UK]',
        val: 0.05204213653931
      }, {
        text: 'gill [US]',
        val: 2
      }, {
        text: 'gill [UK]',
        val: 1.665348369258
      }, {
        text: 'liter',
        val: 0.2365882365
      }, {
        text: 'milliliter',
        val: 236.5882365
      }, {
        text: 'pint [US, fluid]',
        val: 0.5
      }, {
        text: 'pint [US, dry]',
        val: 0.4296811060779
      }, {
        text: 'pint [UK]',
        val: 0.4163370923145
      }, {
        text: 'quart [US, fluid]',
        val: 0.25
      }, {
        text: 'quart [US, dry]',
        val: 0.214840553039
      }, {
        text: 'quart [UK]',
        val: 0.2081685461572
      }, {
        text: 'tablepoon [US]',
        val: 16
      }, {
        text: 'tablepoon [Food and Drug Administration]',
        val: 15.7725491
      }, {
        text: 'teaspoon [US]',
        val: 48
      }, {
        text: 'teaspoon [Food and Drug Administration]',
        val: 47.3176473
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'bit / second (bit/s)',
        val: 1
      }, {
        text: 'byte / second (B/s)',
        val: 0.125
      }, {
        text: 'kilobit / second (Kbit/s)',
        val: 0.0009765625
      }, {
        text: 'kilobyte / second (KB/s)',
        val: 0.0001220703125
      }, {
        text: 'megabit / second (Mbit/s)',
        val: 9.536743164063e-7
      }, {
        text: 'megabyte / second (MB/s)',
        val: 1.192092895508e-7
      }, {
        text: 'gigabit / second (Gbit/s)',
        val: 9.313225746155e-10
      }, {
        text: 'gigabyte / second (GB/s)',
        val: 1.164153218269e-10
      }, {
        text: 'byte / minute (B/min)',
        val: 7.5
      }, {
        text: 'byte / hour (B/h)',
        val: 450
      }, {
        text: 'kilobyte / minute (KB/min)',
        val: 0.00732421875
      }, {
        text: 'kilobyte / hour (KB/h)',
        val: 0.439453125
      }, {
        text: 'megabyte / minute (MB/min)',
        val: 0.000007152557373047
      }, {
        text: 'megabyte / hour (MB/h)',
        val: 0.0004291534423828
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'gram / cubic centimeter (g/cm³)',
        val: 1
      }, {
        text: 'gram / cubic decimeter',
        val: 1000
      }, {
        text: 'gram / cubic meter (g/m³)',
        val: 1000000
      }, {
        text: 'gram / liter',
        val: 1000
      }, {
        text: 'gram / milliliter',
        val: 1
      }, {
        text: 'megagram / cubic centimeter',
        val: 0.00001
      }, {
        text: 'megagram / cubic meter',
        val: 1
      }, {
        text: 'megagram / liter',
        val: 0.001
      }, {
        text: 'megagram / milliliter',
        val: 0.00001
      }, {
        text: 'milligram / cubic centimeter (mg/cm³)',
        val: 1000
      }, {
        text: 'milligram / cubic decimeter',
        val: 1000000
      }, {
        text: 'milligram / cubic meter (mg/m³)',
        val: 1000000000
      }, {
        text: 'milligram / liter',
        val: 1000000
      }, {
        text: 'milligram / milliliter',
        val: 1000
      }, {
        text: 'kilogram / cubic centimeter (kg/cm³)',
        val: 0.001
      }, {
        text: 'kilogram / cubic decimeter',
        val: 1
      }, {
        text: 'kilogram / cubic meter (kg/m³)',
        val: 1000
      }, {
        text: 'kilogram / liter',
        val: 1
      }, {
        text: 'kilogram / milliliter',
        val: 0.001
      }, {
        text: 'ounce / cubic foot',
        val: 998.84737348
      }, {
        text: 'ounce / cubic inch',
        val: 0.57803667444
      }, {
        text: 'ounce / cubic yard',
        val: 26968.879083
      }, {
        text: 'ounce / gallon (U.K.)(oz/gal)',
        val: 160.35860568
      }, {
        text: 'ounce / gallon (U.S.)(oz/gal)',
        val: 133.5264718
      }, {
        text: 'pound / circular mil foot',
        val: 340.4917061
      }, {
        text: 'pound / cubic foot (lb/ft³)',
        val: 62.427960841
      }, {
        text: 'pound / cubic inch (lb/in³)',
        val: 0.036127292153
      }, {
        text: 'pound / cubic yard',
        val: 1685.5549427
      }, {
        text: 'pound / gallon (U.K.)(lb/gal)',
        val: 10.022412855
      }, {
        text: 'pound / gallon (U.S.)(lb/gal)',
        val: 8.3454044873
      }, {
        text: 'grain / cubic foot',
        val: 436995.72588
      }, {
        text: 'grain / cubic inch',
        val: 252.89104507
      }, {
        text: 'grain / cubic yard',
        val: 11798884.599
      }, {
        text: 'grain / gallon (U.K.)',
        val: 70156.889986
      }, {
        text: 'grain / gallon (U.S.)',
        val: 58417.831411
      }, {
        text: 'tonne / cubic centimeter',
        val: 0.00001
      }, {
        text: 'tonne / cubic decimeter',
        val: 0.001
      }, {
        text: 'tonne / cubic meter',
        val: 1
      }, {
        text: 'tonne / liter',
        val: 0.001
      }, {
        text: 'tonne / milliliter',
        val: 0.00001
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Centipoise (cP)',
        val: 1
      }, {
        text: 'Gram per centimeter second (g/(cm·s))',
        val: 0.01
      }, {
        text: 'Kilogram per metre second (kg/(m·s))',
        val: 0.001
      }, {
        text: 'Newton second per square metre (N·s/m²)',
        val: 0.001
      }, {
        text: 'Pascal-second (Pa·s)',
        val: 0.001
      }, {
        text: 'Poise (P)',
        val: 0.01
      }, {
        text: 'Pound-force second per square inch (lbf·s/in²)',
        val: 1.45037737797e-7
      }, {
        text: 'Pound-force second per square foot (lbf·s/ft²)',
        val: 0.0000208854342332
      }, {
        text: 'Pound per foot second (lb/(ft·s))',
        val: 0.00067196897514
      }, {
        text: 'Pound per foot hour (lb/(ft·h))',
        val: 2.419088310502
      }, {
        text: 'Slug per foot second (slug/(ft·s))',
        val: 0.0000208854342332
      }, {
        text: 'Poundal second per square foot',
        val: 0.0001019716212978
      }, {
        text: 'Dyne second per square centimetre (dyn·s/cm²)',
        val: 0.01
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Abcoulomb (abC)',
        val: 1
      }, {
        text: 'Ampere-hour (Ah)',
        val: 0.00277777777778
      }, {
        text: 'Coulomb (C)',
        val: 10
      }, {
        text: 'Elementary charge (e)',
        val: 62415094741540000000
      }, {
        text: 'Faraday (F)',
        val: 0.0001036426864904
      }, {
        text: 'Kilocoulomb (kC)',
        val: 0.01
      }, {
        text: 'Megacoulomb (MC)',
        val: 0.00001
      }, {
        text: 'Microcoulomb (µC)',
        val: 10000000
      }, {
        text: 'Milliampere-hour (mAh)',
        val: 2.77777777778
      }, {
        text: 'Millicoulomb (mC)',
        val: 10000
      }, {
        text: 'Nanocoulomb (nC)',
        val: 10000000000
      }, {
        text: 'Statcoulomb (statC)',
        val: 29979245800
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Abohm (abΩ)',
        val: 1
      }, {
        text: 'Gigaohm (GΩ)',
        val: 1e-18
      }, {
        text: 'Kiloohm (kΩ)',
        val: 1e-12
      }, {
        text: 'Megaohm (MΩ)',
        val: 1e-15
      }, {
        text: 'Microohm (µΩ)',
        val: 0.001
      }, {
        text: 'Milliohm (mΩ)',
        val: 0.000001
      }, {
        text: 'Nanoohm (nΩ)',
        val: 1
      }, {
        text: 'Ohm (Ω)',
        val: 1e-9
      }, {
        text: 'Volt per ampere (V/A)',
        val: 1e-9
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'BTU',
        val: 1
      }, {
        text: 'calorie (cal)',
        val: 251.9957963122
      }, {
        text: 'electronvolt (eV)',
        val: 6.585142305005e21
      }, {
        text: 'erg',
        val: 10550560000
      }, {
        text: 'foot-pound',
        val: 778.1693709679
      }, {
        text: 'gigajoule (GJ)',
        val: 0.000001055056
      }, {
        text: 'joule (J)',
        val: 1055.056
      }, {
        text: 'kilocalorie (kcal)',
        val: 0.2519957963122
      }, {
        text: 'kilojoule (kJ)',
        val: 1.055056
      }, {
        text: 'kilowatt hour (kWh)',
        val: 0.0002930711111111
      }, {
        text: 'megajoule (MJ)',
        val: 0.001055056
      }, {
        text: 'nutrition calorie (Cal)',
        val: 0.2519957963122
      }, {
        text: 'ton of TNT (tn)',
        val: 2.521644359465e-7
      }, {
        text: 'watt hour (Wh)',
        val: 0.2930711111111
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'attonewton',
        val: 1
      }, {
        text: 'centinewton',
        val: 1e-17
      }, {
        text: 'decigram-force',
        val: 1.019716213e-16
      }, {
        text: 'decinewton',
        val: 1e-18
      }, {
        text: 'dekagram-force',
        val: 1.019716213e-18
      }, {
        text: 'dekanewton',
        val: 1e-20
      }, {
        text: 'dyne (dyn)',
        val: 1e-14
      }, {
        text: 'exanewton',
        val: 1e-36
      }, {
        text: 'femtonewton',
        val: 0.001
      }, {
        text: 'giganewton (GN)',
        val: 1e-27
      }, {
        text: 'gram-force',
        val: 1.019716213e-17
      }, {
        text: 'hectonewton',
        val: 1e-21
      }, {
        text: 'joule / meter (J/m)',
        val: 1e-19
      }, {
        text: 'kilogram-force (kgf)',
        val: 1.019716e-20
      }, {
        text: 'kilonewton (kN)',
        val: 1e-22
      }, {
        text: 'kilopond (kp)',
        val: 1.019716e-20
      }, {
        text: 'kip (kip)',
        val: 2.248e-23
      }, {
        text: 'meganewton',
        val: 1e-24
      }, {
        text: 'megapond',
        val: 1.019716213e-23
      }, {
        text: 'micronewton (µN)',
        val: 1e-13
      }, {
        text: 'millinewton (mN)',
        val: 1e-16
      }, {
        text: 'nanonewton (nN)',
        val: 1e-10
      }, {
        text: 'newton (N)',
        val: 1e-19
      }, {
        text: 'ounce-force (ozf)',
        val: 3.5969431019e-19
      }, {
        text: 'petanewton',
        val: 1e-33
      }, {
        text: 'piconewton',
        val: 1e-7
      }, {
        text: 'pond',
        val: 1.019716213e-17
      }, {
        text: 'pound-force (lbf)',
        val: 2.2480894387e-20
      }, {
        text: 'poundal (pdl)',
        val: 7.2330140801e-19
      }, {
        text: 'sthene (sn)',
        val: 1e-22
      }, {
        text: 'teranewton',
        val: 1e-30
      }, {
        text: 'ton-force (long)(tnf)',
        val: 1.0036113566e-23
      }, {
        text: 'ton-force (metric)(tnf)',
        val: 1.019716213e-23
      }, {
        text: 'ton-force (short)(tnf)',
        val: 1.1240447194e-23
      }, {
        text: 'yoctonewton',
        val: 1000000
      }, {
        text: 'yottanewton',
        val: 1e-42
      }, {
        text: 'zeptonewton',
        val: 1000
      }, {
        text: 'zettanewton',
        val: 1e-39
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Foot-candle (fc)',
        val: 1
      }, {
        text: 'Kilolux (klx)',
        val: 0.01076391041671
      }, {
        text: 'Lumen per square centimeter (lm/cm²)',
        val: 0.001076391041671
      }, {
        text: 'Lumen per square meter (lm/m²)',
        val: 10.76391041671
      }, {
        text: 'Lux (lx)',
        val: 10.76391041671
      }, {
        text: 'Microlux (µlx)',
        val: 10763910.41671
      }, {
        text: 'Millilux (mlx)',
        val: 10763.91041671
      }, {
        text: 'Nox',
        val: 10763.91041671
      }, {
        text: 'Phot (ph)',
        val: 0.001076391041671
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      listUnit: [{
        name: 'Length',
        color: 'red accent-2',
        href: '/length'
      }, {
        name: 'Temperature',
        color: 'pink accent-2',
        href: '/temperature'
      }, {
        name: 'Volume',
        color: 'purple accent-2',
        href: '/volume'
      }, {
        name: 'Weight',
        color: 'deep-purple accent-2',
        href: '/weight'
      }, {
        name: 'Time',
        color: 'indigo accent-3',
        href: '/time'
      }, {
        name: 'Acceleration',
        color: 'light-blue darken-2',
        href: '/acceleration'
      }, {
        name: 'Amount of Substance',
        color: 'blue darken-2',
        href: '/amount-of-substance'
      }, {
        name: 'Angle',
        color: 'indigo darken-2',
        href: '/angle'
      }, {
        name: 'Area',
        color: 'teal darken-2',
        href: '/area'
      }, {
        name: 'Astronomical',
        color: 'green darken-2',
        href: '/astronomical'
      }, {
        name: 'Blood Sugar',
        color: 'light-green darken-2',
        href: '/blood-sugar'
      }, {
        name: 'Capacitance',
        color: 'lime darken-2',
        href: '/capacitance'
      }, {
        name: 'Computer Storage',
        color: 'yellow darken-2',
        href: '/computer'
      }, {
        name: 'Cooking',
        color: 'amber darken-2',
        href: '/cooking'
      }, {
        name: 'Data Transfer',
        color: 'orange darken-2',
        href: '/data-transfer'
      }, {
        name: 'Density',
        color: 'deep-orange darken-2',
        href: '/density'
      }, {
        name: 'Dynamic Viscosity',
        color: 'brown darken-2',
        href: '/dynamic-viscosity'
      }, {
        name: 'Electric Charge',
        color: 'blue-grey darken-2',
        href: '/electric-charge'
      }, {
        name: 'Electrical Resistance',
        color: 'grey darken-2',
        href: '/electrical-resistance'
      }, {
        name: 'Energy and Work',
        color: 'red darken-2',
        href: '/energy'
      }, {
        name: 'Force',
        color: 'pink darken-2',
        href: '/force'
      }, {
        name: 'Illuminance',
        color: 'purple darken-2',
        href: '/illuminance'
      }, {
        name: 'Inductance',
        color: 'deep-purple darken-2',
        href: '/inductance'
      }]
    };
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Abhenry (abH)',
        val: 1
      }, {
        text: 'Gigahenry (GH)',
        val: 1e-18
      }, {
        text: 'Henry (H)',
        val: 1e-9
      }, {
        text: 'Kilohenry (kH)',
        val: 1e-12
      }, {
        text: 'Megahenry (MH)',
        val: 1e-15
      }, {
        text: 'Microhenry (µH)',
        val: 0.001
      }, {
        text: 'Millihenry (mH)',
        val: 0.000001
      }, {
        text: 'Nanohenry (nH)',
        val: 1
      }, {
        text: 'Weber per ampere (Wb/A)',
        val: 1e-9
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Meter',
        val: 1
      }, {
        text: 'Kilometer',
        val: 0.001
      }, {
        text: 'Centimeter',
        val: 100
      }, {
        text: 'Millimeter',
        val: 1000000
      }, {
        text: 'Nanometer',
        val: 1000000000
      }, {
        text: 'Mile',
        val: 0.0006213689
      }, {
        text: 'Yard',
        val: 1.0936132983
      }, {
        text: 'Foot',
        val: 3.280839895
      }, {
        text: 'Inch',
        val: 39.37007874
      }, {
        text: 'Light Year',
        val: 1.057008707e-16
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Celsius',
        val: 1
      }, {
        text: 'Kelvin',
        val: 274.15
      }, {
        text: 'Fahrenheit',
        val: 33.8
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Second',
        val: 1
      }, {
        text: 'Millisecond',
        val: 1000
      }, {
        text: 'Nanosecond',
        val: 1000000000
      }, {
        text: 'Picosecond',
        val: 1000000000000
      }, {
        text: 'Minute',
        val: 1 / 60
      }, {
        text: 'Hour',
        val: 1 / 3600
      }, {
        text: 'Day',
        val: 1 / 86400
      }, {
        text: 'Week',
        val: 1 / 604800
      }, {
        text: 'Month',
        val: 3.802570537e-7
      }, {
        text: 'Year',
        val: 3.168808781e-8
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Cubic Meter',
        val: 1
      }, {
        text: 'Cubic Kilometer',
        val: 1e-9
      }, {
        text: 'Cubic Centimeter',
        val: 1000000
      }, {
        text: 'Cubic Millimeter',
        val: 1000000000
      }, {
        text: 'Liter',
        val: 1000
      }, {
        text: 'Milliliter',
        val: 1000000
      }, {
        text: 'US Gallon',
        val: 264.17217686
      }, {
        text: 'US Quart',
        val: 1056.6887074
      }, {
        text: 'US Pint',
        val: 2113.3774149
      }, {
        text: 'US Cup',
        val: 4226.7548297
      }, {
        text: 'US Fluid Ounce',
        val: 33814.038638
      }, {
        text: 'US Table Spoon',
        val: 67628.077276
      }, {
        text: 'US Tea Spoon',
        val: 202884.23183
      }, {
        text: 'Imperial Gallon',
        val: 219.9692483
      }, {
        text: 'Imperial Quart',
        val: 879.8769932
      }, {
        text: 'Imperial Pint',
        val: 1759.7539864
      }, {
        text: 'Imperial Fluid Ounce',
        val: 35195.079728
      }, {
        text: 'Imperial Table Spoon',
        val: 56312.127565
      }, {
        text: 'Imperial Tea Spoon',
        val: 168936.38269
      }, {
        text: 'Cubic Mile',
        val: 2.399128636e-10
      }, {
        text: 'Cubic Yard',
        val: 1.3079506193
      }, {
        text: 'Cubic Foot',
        val: 35.314666721
      }, {
        text: 'Cubic Inch',
        val: 61023.744095
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConvertBox__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ConvertBox: __WEBPACK_IMPORTED_MODULE_0__components_ConvertBox___default.a },
  data: function data() {
    return {
      unit: [{
        text: 'Kilogram',
        val: 1
      }, {
        text: 'Gram',
        val: 1000
      }, {
        text: 'Milligram',
        val: 1000000
      }, {
        text: 'Metric Ton',
        val: 0.001
      }, {
        text: 'Long Ton',
        val: 0.0009842073
      }, {
        text: 'Short Ton',
        val: 0.0011023122
      }, {
        text: 'Pound',
        val: 2.2046244202
      }, {
        text: 'Ounce',
        val: 35.273990723
      }, {
        text: 'Carrat',
        val: 5000
      }, {
        text: 'Atomic Mass Unit',
        val: 6.022136652e26
      }]
    };
  },
  created: function created() {
    this.$store.dispatch('setUnit', this.unit);
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(5);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






var options = {
  rtl: false
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, options);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function convert(unitFrom, unitTo, valueFrom) {
  var units = [{
    name: 'Celsius',
    val: 0
  }, {
    name: 'Fahrenheit',
    val: 0
  }, {
    name: 'Kelvin',
    val: 0
  }];
  valueFrom = parseFloat(valueFrom);
  var index = units.findIndex(function (temp) {
    return temp.name === unitTo;
  });
  var C = valueFrom ? valueFrom : 0;
  if (unitFrom === 'Fahrenheit') {
    C = (valueFrom - 32) * 5 / 9;
  } else if (unitFrom === 'Kelvin') {
    C = valueFrom - 273.15;
  }
  var F = C / 5 * 9 + 32;
  var K = C + 273.15;
  units[0].val = C.toString();
  units[1].val = F.toString();
  units[2].val = K.toString();
  return units[index].val;
}

/* harmony default export */ __webpack_exports__["a"] = (convert);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(98),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(99),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(111),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(103),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(113),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(94),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(102),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(109),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(104),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(101),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(105),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(93),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(96),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(108),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(95),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(100),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(112),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(97),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(110),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(89),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(107),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(37)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(90),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(91),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Temperature")]), _vm._v(" "), _c('convert-box', {
    attrs: {
      "type": "temperature"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Volume")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Weight")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.unit,
      "label": "Select",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.unitFrom.text),
      callback: function($$v) {
        _vm.$set(_vm.unitFrom, "text", $$v)
      },
      expression: "unitFrom.text"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.unit,
      "label": "Select",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.unitTo.text),
      callback: function($$v) {
        _vm.$set(_vm.unitTo, "text", $$v)
      },
      expression: "unitTo.text"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "grid-list-md": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "From",
      "type": "number"
    },
    model: {
      value: (_vm.valueFrom),
      callback: function($$v) {
        _vm.valueFrom = $$v
      },
      expression: "valueFrom"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg5": "",
      "md6": "",
      "offset-xs1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.valueTo ? _vm.valueTo : 'To',
      "disabled": "",
      "type": "number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.copy()
      }
    }
  }, [_vm._v("Copy")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Exponent",
      "color": "primary"
    },
    model: {
      value: (_vm.exponent),
      callback: function($$v) {
        _vm.exponent = $$v
      },
      expression: "exponent"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg2": "",
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Round number",
      "color": "primary"
    },
    model: {
      value: (_vm.round),
      callback: function($$v) {
        _vm.round = $$v
      },
      expression: "round"
    }
  })], 1), _vm._v(" "), (_vm.round) ? _c('v-flex', {
    attrs: {
      "lg3": "",
      "sm3": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": ("Rounding number to " + _vm.roundNumber + " decimal places")
    },
    model: {
      value: (_vm.roundNumber),
      callback: function($$v) {
        _vm.roundNumber = $$v
      },
      expression: "roundNumber"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "bottom": true,
      "color": "primary"
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    Copy successful\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Electric Charge")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Blood sugar")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Force")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Electrical Resistance")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Inductance")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Acceleration")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Amount of Substance")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Illuminance")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Density")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Capacitance")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Area")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Data transfer")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Dynamic Viscosity")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-navigation-drawer', {
    attrs: {
      "persistent": "",
      "mini-variant": _vm.miniVariant,
      "clipped": _vm.clipped,
      "enable-resize-watcher": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": "",
        "d-none": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n              " + _vm._s(item.heading) + "\n            ")]) : _vm._e()], 1)], 1) : (item.divider) ? _c('v-divider', {
      key: i,
      staticClass: "my-1",
      attrs: {
        "dark": ""
      }
    }) : _c('v-list-tile', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.$router.push(item.href)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "vl-header",
      "dark": "",
      "fixed": "",
      "app": "",
      "clipped-left": _vm.clipped
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.miniVariant = !_vm.miniVariant
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clipped = !_vm.clipped
      }
    }
  }, [_c('v-icon', [_vm._v("web")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "text-right w-100",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('main', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "fixed": _vm.fixed,
      "app": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0"
  }, [_c('span', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "https://vajralab.com",
      "target": "_blank"
    }
  }, [_vm._v("VajraLab")]), _vm._v(" © 2019-2023")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Time")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Energy and Work")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Computer Data Storage")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Length")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Angle")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-parallax', {
    attrs: {
      "src": "https://chuszoof.files.wordpress.com/2014/11/material_wallpaper_set_two-1.jpg"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('h1', {
    staticClass: "white--text display-3"
  }, [_vm._v("Unit Converter")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.listUnit), function(unit, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs4": ""
      }
    }, [_c('v-card', {
      staticClass: "white--text mr-2 mb-2",
      attrs: {
        "color": unit.color
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', {
      staticClass: "headline"
    }, [_vm._v(_vm._s(unit.name))])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$router.push(unit.href)
        }
      }
    }, [_vm._v("Convert now")])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Astronomical")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("Cooking")]), _vm._v(" "), _c('convert-box')], 1)], 1)
},staticRenderFns: []}

/***/ })
],[34]);


// WEBPACK FOOTER //
// static/js/app.984ce217b639ad41d405.js